var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 273,
    viewBox: "0 0 272 273",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M248.983 128.193H245.745V208.303H248.983V128.193Z",
    fill: "#23293F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7908 180.002H21.5527V68.2039C21.5527 62.3689 26.2998 57.6218 32.1348 57.6218H238.531C244.366 57.6218 249.113 62.3689 249.113 68.2039V120.098H245.875V68.2039C245.875 64.1563 242.579 60.8599 238.531 60.8599H32.1348C28.0872 60.8599 24.7908 64.1563 24.7908 68.2039V180.002Z",
    fill: "#23293F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7908 189.717H21.5527V208.815H24.7908V189.717Z",
    fill: "#23293F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M247.663 85.5276H28.9941V88.7657H247.663V85.5276Z",
    fill: "#23293F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1035 77.918C40.8025 77.918 42.1797 76.5407 42.1797 74.8418C42.1797 73.1429 40.8025 71.7656 39.1035 71.7656C37.4046 71.7656 36.0273 73.1429 36.0273 74.8418C36.0273 76.5407 37.4046 77.918 39.1035 77.918Z",
    fill: "#23293F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1631 77.918C54.862 77.918 56.2393 76.5407 56.2393 74.8418C56.2393 73.1429 54.862 71.7656 53.1631 71.7656C51.4642 71.7656 50.0869 73.1429 50.0869 74.8418C50.0869 76.5407 51.4642 77.918 53.1631 77.918Z",
    fill: "#23293F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2295 77.918C68.9284 77.918 70.3057 76.5407 70.3057 74.8418C70.3057 73.1429 68.9284 71.7656 67.2295 71.7656C65.5306 71.7656 64.1533 73.1429 64.1533 74.8418C64.1533 76.5407 65.5306 77.918 67.2295 77.918Z",
    fill: "#23293F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M201.552 213.031H67.7988V112.015H176.269V137.298L201.552 136.754V213.031Z",
    fill: "#B0B6EE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M203.275 207.895H200.037V137.078L175.499 113.719H69.6258V207.895H66.3877V110.48H176.794L203.275 135.692V207.895Z",
    fill: "#23293F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M193.302 139.014H174.527V112.099H177.765V135.776H193.302V139.014Z",
    fill: "#23293F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M159.742 194.898H155.746C150.675 188.447 142.91 184.607 134.484 184.607C126.059 184.607 118.307 188.454 113.23 194.898H109.24C114.823 186.479 124.226 181.369 134.484 181.369C144.743 181.369 154.159 186.472 159.742 194.898Z",
    fill: "#F4F5F7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M118.489 161.869H113.904L100.304 148.269H104.889L109.234 152.615L111.527 154.907L118.489 161.869Z",
    fill: "#F4F5F7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M105.646 155.555L107.939 157.847L103.917 161.869H99.332L105.646 155.555Z",
    fill: "#F4F5F7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M117.517 148.269L110.231 155.555L109.583 154.907L107.938 153.262L108.586 152.615L112.932 148.269H117.517Z",
    fill: "#F4F5F7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M169.651 161.869H165.066L151.466 148.269H156.051L160.396 152.615L162.689 154.907L169.651 161.869Z",
    fill: "#F4F5F7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M156.808 155.555L159.101 157.847L155.079 161.869H150.494L156.808 155.555Z",
    fill: "#F4F5F7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M168.679 148.269L161.393 155.555L160.746 154.907L159.101 153.262L159.748 152.615L164.094 148.269H168.679Z",
    fill: "#F4F5F7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M268.386 211.03H258.672V214.268H268.386V211.03Z",
    fill: "#23293F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M254.786 211.03H2.8623V214.268H254.786V211.03Z",
    fill: "#23293F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M230.604 73.3911H217.088V76.6292H230.604V73.3911Z",
    fill: "#23293F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M259.579 122.267H244.081V125.505H259.579V122.267Z",
    fill: "#23293F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M269.785 129.527H254.56V132.765H269.785V129.527Z",
    fill: "#23293F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8771 173.688H5.45312V176.926H16.8771V173.688Z",
    fill: "#23293F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7672 183.538H2.21484V186.776H28.7672V183.538Z",
    fill: "#23293F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/error404.4f3647b8771b2b069080be256308cc45.svg";
export { ForwardRef as ReactComponent };